/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import { Trans } from '@lingui/react'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { withI18n } from 'shared/utils/withI18n'
import Button from 'views/components/atoms/Button'
import IconTick from 'views/components/atoms/Icon/IconTick'
import ButtonTooltip from 'views/components/molecules/ButtonTooltip'
import Select from 'views/components/molecules/Select'
import ProductStatus from 'views/components/organisms/ProductStatus'
import useShopAndRuntimeConfig from 'views/enhancers/useShopAndRuntimeConfig'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'
import buildClientAPI from 'views/providers/clientAPI'
import { isProductAvailable } from 'views/utils/productUtils'
import { i18nType } from 'views/utils/propTypes'

import BuyBoxDeliveryCosts from './BuyBoxDeliveryCosts'

const BuyBoxSendEmail = ({ i18n }) => {
  const config = useShopAndRuntimeConfig()
  const {
    productId: id,
    product: { stockStatus },
  } = config.publicRuntimeConfig.pageProperties

  const isAvailable = isProductAvailable(stockStatus)

  const isCustomerLoggedIn = useSelector(state => state.userSession.isLoggedIn)

  const [isCustomerSubscribed, setIsCustomerSubscribed] = useState(false)

  useEffect(() => {
    function fetchCustomerSubScriptionStatus() {
      buildClientAPI()
        .reavailabilityService.fetchCustomerSubScriptionStatus(id)
        .then(res => setIsCustomerSubscribed(res.data.isCustomerSubscribed))
    }
    if (isCustomerLoggedIn) {
      fetchCustomerSubScriptionStatus()
    }
  }, [id, isCustomerLoggedIn])

  const onSubmit = event => {
    event.preventDefault()

    buildClientAPI()
      .reavailabilityService.createSubscribeCustomerToProduct(id)
      .then(res => setIsCustomerSubscribed(res.data.isCustomerSubscribed))
  }

  return (
    <div name={`email-on-availability-${id}-id`}>
      <div className="l-flex u-margin--bottom@medium u-margin-large--bottom@small-tiny o-BuyBoxSendEmailForm--status">
        <div className="l-flex__primary">
          <ProductStatus stockStatus={stockStatus} />
        </div>
        {isAvailable && (
          <BuyBoxDeliveryCosts
            isFreeDelivery={false}
            prescriptionType={null}
            useLink
          />
        )}
      </div>
      <div className="l-flex o-BuyBoxSendEmailForm--form">
        <div className="u-margin-large--right o-BuyBox__grow--one-quarter@small-tiny o-BuyBoxSendEmailForm--form-select">
          <Select
            id="product_quantity_BuyBox"
            name="quantity"
            label={i18n._('general.label.quantity')}
            options={[{ value: 1, text: '1' }]}
            floatingLabel
            disabled
          />
        </div>
        <div className="l-flex__primary o-BuyBox__grow--three-quarter@small-tiny o-BuyBoxSendEmailForm__button_activate">
          {!isCustomerLoggedIn && (
            <ButtonTooltip
              name="send-email-notification-tooltip"
              id="send-email-notification-tooltip"
              text={i18n._('general.loginRequired')}
              buttonText={i18n._('backInStock.button.activate')}
              ButtonType={Button}
              inline={false}
              fullWidth
            />
          )}
          {isCustomerLoggedIn && (
            <Button
              name="email-on-availability-button"
              onClick={onSubmit}
              disabled={isCustomerSubscribed}
            >
              {!isCustomerSubscribed && (
                <span className="a-h3 u-no-margin u-font-weight--normal">
                  <Trans id="backInStock.button.activate" />
                </span>
              )}
              {isCustomerSubscribed && (
                <span className="a-h3 u-no-margin u-font-weight--normal">
                  <Trans id="backInStock.label.active" />
                  <IconTick />
                </span>
              )}
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

BuyBoxSendEmail.propTypes = {
  i18n: i18nType.isRequired,
}

export default withI18n()(BuyBoxSendEmail, withShopAndRuntimeConfig)
